import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem
} from '@mui/material';
import api from '../services/api';

const SubjectManagement = () => {
    const [subjects, setSubjects] = useState([]);
    const [faculties, setFaculties] = useState([]);
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        faculty_id: '',
        time_slot_start: '09:00',
        time_slot_end: '10:00',
        days_of_week: 'Mon,Tue,Wed,Thu,Fri'
    });

    useEffect(() => {
        fetchSubjects();
        fetchFaculties();
    }, []);

    const fetchSubjects = async () => {
        try {
            const res = await api.get('/admin/subjects');
            setSubjects(res.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchFaculties = async () => {
        try {
            const res = await api.get('/admin/users?role=faculty');
            setFaculties(res.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async () => {
        try {
            await api.post('/admin/subjects', formData);
            setOpen(false);
            fetchSubjects();
        } catch (error) {
            alert('Failed to create subject');
        }
    };

    return (
        <Box p={4}>
            <Box display="flex" justifyContent="space-between" mb={4}>
                <Typography variant="h4">Subject Management</Typography>
                <Button variant="contained" onClick={() => setOpen(true)}>Add Subject</Button>
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Teacher</TableCell>
                            <TableCell>Schedule</TableCell>
                            <TableCell>Days</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {subjects.map((s) => (
                            <TableRow key={s.id}>
                                <TableCell>{s.code}</TableCell>
                                <TableCell>{s.name}</TableCell>
                                <TableCell>{s.faculty_name}</TableCell>
                                <TableCell>{s.time_slot_start} - {s.time_slot_end}</TableCell>
                                <TableCell>{s.days_of_week}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Add New Subject</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField label="Code" fullWidth value={formData.code} onChange={(e) => setFormData({ ...formData, code: e.target.value })} />
                    <TextField label="Name" fullWidth value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                    <TextField select label="Teacher" fullWidth value={formData.faculty_id} onChange={(e) => setFormData({ ...formData, faculty_id: e.target.value })}>
                        {faculties.map(f => <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>)}
                    </TextField>
                    <TextField label="Start Time" type="time" fullWidth value={formData.time_slot_start} onChange={(e) => setFormData({ ...formData, time_slot_start: e.target.value })} />
                    <TextField label="End Time" type="time" fullWidth value={formData.time_slot_end} onChange={(e) => setFormData({ ...formData, time_slot_end: e.target.value })} />
                    <TextField label="Days (comma separated)" fullWidth value={formData.days_of_week} onChange={(e) => setFormData({ ...formData, days_of_week: e.target.value })} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleSubmit}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default SubjectManagement;
